import { Howl } from "howler";

export default class SoundClass {

  constructor(app, lib) {
    console.log('sound constructor');
    this.app = app;
    this.currentLib = null;

    if (lib === 'main_library') this.initMainSounds();
  }

  init(part) {

  }

  play(sound) {
    if (this.app.params && this.app.params.users && this.app.params.users > 1) return false;

    if ((this.app.params && this.app.params.sounds) || !this.app.params) {
      this.start_play(sound);
    }
  }

  start_play(part = 'cif2') {
    this.currentLib.play(part);
  }

  // inits
  initMainSounds() {
    console.log('init main sound');
    this.currentLib = new Howl(
      {
        src: ["storage/app/media/sounds/sounds.mp3"],
        sprite: {
          "click1": [
            0,
            809.795918367347
          ],
          "click2": [
            2000,
            992.6530612244898
          ],
          "click3": [
            4000,
            1253.8775510204082
          ],
          "cif1": [
            7000,
            1645.714285714286
          ],
          "cif2": [
            10000,
            2037.551020408163
          ],
          "no": [
            14000,
            783.6734693877556
          ],
          "yes1": [
            16000,
            3030.204081632654
          ],
          "yes2": [
            21000,
            3030.204081632654
          ]
        }
      });
  }

}